import {
  ChartCategory,
  ChartId,
  ChartSlug,
} from "@/features/analysis/types/chart";

type ChartConfig = {
  category: ChartCategory;
  chartId: ChartId;
};

const CHART_MAPPING: Record<ChartSlug, ChartConfig> = {
  // financial
  "revenue-breakdown": {
    category: "financial",
    chartId: "revenue-breakdown-chart",
  },
  EPS: {
    category: "financial",
    chartId: "eps-chart",
  },
  "diluted-EPS": {
    category: "financial",
    chartId: "eps-diluted-chart",
  },
  revenue: {
    category: "financial",
    chartId: "revenue-chart",
  },
  "operating-income": {
    category: "financial",
    chartId: "operation-income-chart",
  },
  "net-income": {
    category: "financial",
    chartId: "net-income-chart",
  },
  "operating-expenses": {
    category: "financial",
    chartId: "operating-expenses-chart",
  },
  "cash-flow": {
    category: "financial",
    chartId: "cash-flow-chart",
  },
  "cash-and-debt": {
    category: "financial",
    chartId: "cash-and-debt-chart",
  },

  // valuation
  "pe-ratio": {
    category: "valuation",
    chartId: "pe-ratio-chart",
  },
  "ps-ratio": {
    category: "valuation",
    chartId: "ps-ratio-chart",
  },
  "pb-ratio": {
    category: "valuation",
    chartId: "pb-ratio-chart",
  },
  "forward-pe": {
    category: "valuation",
    chartId: "forward-pe-chart",
  },
  "ev-ebitda": {
    category: "valuation",
    chartId: "ev-to-ebitda-chart",
  },
  "ev-sales": {
    category: "valuation",
    chartId: "ev-to-sales-chart",
  },
  "pe-ratio-river": {
    category: "valuation",
    chartId: "pe-stream-chart",
  },

  // growth
  "peg-ratio": {
    category: "growth",
    chartId: "peg-ratio-chart",
  },
  "eps-surprise-ratio": {
    category: "growth",
    chartId: "eps-surprise-chart",
  },
  "revenue-surprise-ratio": {
    category: "growth",
    chartId: "revenue-surprise-chart",
  },

  // profitability
  "roe-roa": {
    category: "profitability",
    chartId: "operating-roa-chart",
  },
  ros: {
    category: "profitability",
    chartId: "ros-chart",
  },
  "profitability-ratios": {
    category: "profitability",
    chartId: "profit-margin-chart",
  },
};

export const getCategoryBySlug = (slug: ChartSlug) => {
  return CHART_MAPPING[slug].category;
};

export const getChartIdBySlug = (slug: ChartSlug) => {
  return CHART_MAPPING[slug].chartId;
};
